<div class="profile-card__divider"></div>
@if (mfa.isLoaded) {
  <div class="profile-field profile-field--toggle">
    <div class="profile-field__left">
      <div class="profile-field__label">
        <lucide-icon name="ShieldCheck" [size]="16"></lucide-icon>
        <span>{{ 'profile.mfa.title' | transloco }}</span>
      </div>
      @if (mfa.loadError) {
        <p class="profile-field__description profile-field__description--error" role="alert">
          {{ 'profile.mfa.loadError' | transloco }}
          <app-button [label]="'common.actions.retry' | transloco" variant="secondary" size="small" (onClick)="mfa.load()"></app-button>
        </p>
      } @else {
        <p class="profile-field__description">{{ 'profile.mfa.description' | transloco }}</p>
      }
    </div>
    <app-toggle-switch
      [(ngModel)]="mfa.enabled"
      [ngModelOptions]="{standalone: true}"
      (ngModelChange)="onToggleChange($event)"
      [disabled]="disabled || mfa.isEnrolling || mfa.loadError"
      size="large"
    ></app-toggle-switch>
  </div>
} @else {
  <div class="profile-skeleton__field">
    <p-skeleton width="60%" height="16px"></p-skeleton>
    <p-skeleton width="44px" height="26px" borderRadius="13px"></p-skeleton>
  </div>
}
